var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8499 10.35H12.6501V1.14993C12.6501 0.515268 12.1348 0 11.4999 0C10.8653 0 10.35 0.515268 10.35 1.14993V10.35H1.14993C0.515268 10.35 0 10.8653 0 11.4999C0 12.1348 0.515268 12.6501 1.14993 12.6501H10.35V21.8499C10.35 22.4848 10.8653 23.0001 11.4999 23.0001C12.1348 23.0001 12.6501 22.4848 12.6501 21.8499V12.6501H21.8499C22.4848 12.6501 23.0001 12.1348 23.0001 11.4999C23.0001 10.8653 22.4848 10.35 21.8499 10.35Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLarge);
export default __webpack_public_path__ + "static/media/plus-large.023290421898c1950dd0eb440e519d37.svg";
export { ForwardRef as ReactComponent };